import React from "react";
import { Modal, Typography, Box, Backdrop, Button } from '@mui/material';
import { useThemes } from "../Theme/theme";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    outline: "none",
    borderRadius: "4px"
};

const ConfirmDeleteModal = ({ open, setOpen, storage, itemId }) => {
    const { theme } = useThemes()

    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            setOpen(false);
        }
    }

    const deleteItem = () => {
        let arr = JSON.parse(localStorage.getItem(storage)).filter((obj) => {
            if (obj.id != itemId) {
                return obj
            }
        })
        localStorage.setItem(storage, JSON.stringify(arr));
        setOpen(false);
    }

    return (

        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            {/* <Fade in={open}> */}
            <Box sx={style}>
                <Box sx={{
                    borderRadius: "4px",
                    padding: "15px",
                    textAlign: "center",
                    overflowY: { xs: 'scroll', sm: 'hidden' },
                    '.MuiTableCell-root': {
                        padding: '10px 10px',
                        fontSize: '13px'
                    },
                }}>

                    <Typography sx={{ color: theme?.palette?.TmId.id.toString().includes("9") ? "#FFF1E6" : "rgb(60 60 60)", fontWeight: "bold" }}>
                        Do you want to delete this item?
                    </Typography>

                </Box>


                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: "row",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    paddingBottom: "15px",
                }}>
                    <Button onClick={handleClose} variant='outlined' sx={{ flex: 1, margin: '5px', fontSize: "12px" }} >No</Button>
                    <Button color="error" onClick={deleteItem} variant='contained' sx={{ flex: 1, margin: '5px', fontSize: "12px" }} >Yes</Button>
                </Box>


            </Box>
            {/* </Fade> */}
        </Modal>

    );
};

export default ConfirmDeleteModal;